import Home from "./pages/Home.vue";
import { createRouter, createWebHistory } from "vue-router";
import Login from "@/pages/auth/Login.vue";
import NotFound from "./pages/NotFound.vue";
import Register from "./pages/auth/Register.vue";
import { useUserStore } from "./stores/user";
import Admin from "./pages/Admin.vue";
import OurProjects from "./pages/OurProjects.vue";
import Projects from "./pages/admin/Projects.vue";
import Configurations from "./pages/admin/Configurations.vue";
import About from "@/pages/About.vue";
import Services from "@/pages/Services.vue";
import Partners from "@/pages/admin/Partners.vue";
import Project from "@/pages/Project.vue";
import Estimations from "./pages/admin/Estimations.vue";
import MyOrders from "./pages/admin/MyOrders.vue";
import Users from "./pages/admin/Users.vue";

const routes = [
    {
        //home page
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: 'Home',
            layout: 'app-layout',
            requiresAuth: false,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: 'login',
            layout: 'AppLayout',
            requiresAuth: false,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/:pathMatch(.*)*', // Catch-all route
        name: 'NotFound',
        component: NotFound,
        meta: {
            requiresAuth: false,
        }
    },
    {
        path: '/admin',
        name: 'admin',
        component: Admin,
        meta: {
            title: '',
            layout: 'admin-layout',
            requiresAuth: true,
        },
        beforeEnter: async (_to: any, _from: any, next: any) => {
            // Check if the user is authenticated  
            const userStore = useUserStore();
            //await userStore.fetchUser();
            const user = await userStore.getUser();
            if (!user || user.id == null || user.id == undefined || user.ly > 10) {
                next({ name: 'home' });
            } else {
                next();
            }
        }
    },
    {
        path: '/admin/projects',
        name: 'projects',
        component: Projects,
        meta: {
            title: 'Projects',
            layout: 'admin-layout',
            requiresAuth: true,
        },

        beforeEnter: async (_to: any, _from: any, next: any) => {
            // Check if the user is authenticated
            const userStore = useUserStore();
            //await userStore.fetchUser();
            // Check if the user has the required role
            const user = await userStore.getUser();
            if (user.ly > 3) {
                next({ name: 'home' });
            } else {
                next();
            }
        }

    },
    {
        path: '/admin/config',
        name: 'configurations',
        component: Configurations,
        meta: {
            title: 'Configurations',
            layout: 'admin-layout',
            requiresAuth: true,
        },
        beforeEnter: async (_to: any, _from: any, next: any) => {
            // Check if the user is authenticated
            const userStore = useUserStore();
            //await userStore.fetchUser();
            // Check if the user has the required role
            const user = await userStore.getUser();
            if (user.ly > 3) {
                next({ name: 'home' });
            } else {
                next();
            }
        }
    },
    {
        path: '/admin/partners',
        name: 'partners',
        component: Partners,
        meta: {
            title: 'Partners',
            layout: 'admin-layout',
            requiresAuth: true,
        },

        beforeEnter: async (_to: any, _from: any, next: any) => {
            // Check if the user is authenticated
            const userStore = useUserStore();
            //await userStore.fetchUser();
            // Check if the user has the required role
            const user = await userStore.getUser();
            if (user.ly > 3) {
                next({ name: 'home' });
            } else {
                next();
            }
        }

    },
    {
        path: '/admin/users',
        name: 'users',
        component: Users,
        meta: {
            title: 'Users',
            layout: 'admin-layout',
            requiresAuth: true,
        },

        beforeEnter: async (_to: any, _from: any, next: any) => {
            // Check if the user is authenticated
            const userStore = useUserStore();
            //await userStore.fetchUser();
            // Check if the user has the required role
            const user = await userStore.getUser();
            if (user.ly > 3) {
                next({ name: 'home' });
            } else {
                next();
            }
        }

    },
    {
        path: '/admin/estimations',
        name: 'estimations',
        component: Estimations,
        meta: {
            title: 'Estimations',
            layout: 'admin-layout',
            requiresAuth: true,
        },

        beforeEnter: async (_to: any, _from: any, next: any) => {
            // Check if the user is authenticated
            const userStore = useUserStore();
            //await userStore.fetchUser();
            // Check if the user has the required role
            const user = await userStore.getUser();
            if (user.ly > 3) {
                next({ name: 'home' });
            } else {
                next();
            }
        }

    },
    {
        path: '/admin/my-orders',
        name: 'myorders',
        component: MyOrders,
        meta: {
            title: 'My Orders',
            layout: 'admin-layout',
            requiresAuth: true,
        },

        beforeEnter: async (_to: any, _from: any, next: any) => {
            // Check if the user is authenticated
            const userStore = useUserStore();
            //await userStore.fetchUser();
            // Check if the user has the required role
            const user = await userStore.getUser();
            if (user.ly > 10) {
                next({ name: 'home' });
            } else {
                next();
            }
        }

    },
    {
        path: '/projects',
        name: 'our-projects',
        component: OurProjects,
        meta: {
            title: 'Our Projects',
            layout: 'app-layout',
            requiresAuth: false,
        },
    },
    {
        path: '/project/:id',
        name: 'project-details',
        component: Project,
        meta: {
            title: 'project-details',
            layout: 'app-layout',
            requiresAuth: false,
        },
    },
    {
        path: '/about',
        name: 'about',
        component: About,
        meta: {
            title: 'about',
            layout: 'app-layout',
            requiresAuth: false,
        },
    },
    {
        path: '/services',
        name: 'our-services',
        component: Services,
        meta: {
            title: 'our-services',
            layout: 'app-layout',
            requiresAuth: false,
        },
    },
];
//create base router
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: routes,
});

export default router;